import axios from 'axios';
import React, { useEffect, useState } from 'react';

import './language.css';

const Language = () => {
    /*
    const [languageList, setLanguageList] = useState([])
    const [newLanguage, setNewLanguage] = useState({ language: '' })
    const [isEdit, setIsEdit] = useState(false)
    const [editId, setEditId] = useState(null)
    // const [language, setLanguage] = useState("")



    const deleteLanguage = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/language/${id}`)
            if (response.data.result) {
                console.log("language deleted Successfully!!");
            }

        } catch (error) {
            console.error(error);

        }
    }


    const getOneLanguage = async (id) => {
        console.log(id);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/language/${id}`)
            if (response) {
                console.log(response);
                setNewLanguage({ language: response.data.language })
                setIsEdit(true);
                setEditId(id);
            }

        } catch (error) {
            console.error(error);

        }
    }

*/

    const [languages, setLanguages] = useState([]);
    const [currentLanguage, setCurrentLanguage] = useState('');
    const [editIndex, setEditIndex] = useState(null);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchLanguageData()
    }, [])

    const fetchLanguageData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/language`)
            if (response) {
                setLanguages(response.data)
            }
        } catch (error) {
            console.error(error);

        }
    }

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {language: currentLanguage};
        if (editIndex !== null) {
            try {
                const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/language/${editIndex}`, payload)

                if (response.data.result) {
                    setMessage("language added Successfully!!");
                }

            } catch (error) {
                console.error(error);
            }

        } else {
            try {
                const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/language`, payload)
                if (response.data.result) {
                    setMessage("language added Successfully!!");
                }
            } catch (error) {
                console.error(error);
            }
        }
        
        await fetchLanguageData();

        setCurrentLanguage('');  // Clear input
        setEditIndex(null);  // Reset editing state
    };

    // Handle edit
    const handleEdit = (index) => {
        setCurrentLanguage(languages[index].language);
        setEditIndex(languages[index]._id);
    };

    // Handle delete
    const handleDelete = async (index) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete ${languages[index].language} language?`);
  
        if (confirmDelete) {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/language/${languages[index]._id}`)
            if (response.data.result) {
                setMessage(`language ${languages[index].language} deleted Successfully!!`);
            }
            await fetchLanguageData();
        }

       
    };

    return (
        <div className="container mt-5">
            <div className="row">
                {/* Left Section: Form */}
                <div className="col-md-5">
                    <h3>{editIndex !== null ? 'Edit Language' : 'Add Language'}</h3>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="language" className="form-label">Enter Language name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="language"
                                value={currentLanguage}
                                onChange={(e) => setCurrentLanguage(e.target.value)}
                                required
                                placeholder="Enter language"
                            />
                        </div>
                        <button type="submit" className="btn btn-dark">
                            {editIndex !== null ? 'Update' : 'Add'} Language
                        </button>
                        <p>{message}</p>
                    </form>
                </div>

                {/* Right Section: Table */}
                <div className="col-md-7">
                    <h3>Item List</h3>
                    {languages.length === 0 ? (
                        <p>
                            No languages added
                        </p>
                    ) : (
                        <ul class="list-group">
                            {
                                languages.map((item, index) =>
                                (
                                    <li key={index} class="list-group-item d-flex justify-content-between align-items-center">
                                        <span> {item.language}</span>
                                        <div className='btn-actions-wrapper'>
                                            <button
                                                className="btn btn-warning btn-sm me-2"
                                                onClick={() => handleEdit(index)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(index)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Language